import { Link } from 'react-router-dom';

export type Crumb = {
  label: string;
  to?: string;
};

type BreadcrumbProps = {
  items: Crumb[];
  tone?: 'light' | 'dark';
};

export default function Breadcrumb({ items, tone = 'light' }: BreadcrumbProps) {
  const isDark = tone === 'dark';
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-2 text-xs md:text-sm">
      <Link
        to="/"
        className={`transition-colors ${isDark ? 'text-background-50/70 hover:text-background-50' : 'text-foreground-500 hover:text-primary-600'}`}
      >
        首页
      </Link>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={`${item.label}-${index}`} className="flex items-center gap-2">
            <span className="flex h-3 w-3 items-center justify-center text-[10px] opacity-50">
              <i className="ri-arrow-right-s-line" />
            </span>
            {item.to && !isLast ? (
              <Link
                to={item.to}
                className={`transition-colors ${isDark ? 'text-background-50/70 hover:text-background-50' : 'text-foreground-500 hover:text-primary-600'}`}
              >
                {item.label}
              </Link>
            ) : (
              <span className={isDark ? 'text-background-50' : 'text-primary-600'}>{item.label}</span>
            )}
          </span>
        );
      })}
    </nav>
  );
}